// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.nash-chat-trigger {
  transition: box-shadow 200ms ease, transform 200ms ease;
}

.nash-chat-ring-active {
  box-shadow: 0 0 0 4px rgba(224, 242, 254, 0.95), 0 0 0 8px rgba(34, 211, 238, 0.45),
    0 0 0 12px rgba(59, 130, 246, 0.25);
}

@keyframes nash-chat-vibrate {
  0%,
  100% {
    transform: translate3d(0, 0, 0);
  }
  20% {
    transform: translate3d(-0.6px, 0.6px, 0);
  }
  40% {
    transform: translate3d(0.6px, -0.6px, 0);
  }
  60% {
    transform: translate3d(-0.6px, -0.6px, 0);
  }
  80% {
    transform: translate3d(0.6px, 0.6px, 0);
  }
}

.nash-chat-vibrate {
  animation: nash-chat-vibrate 0.55s linear infinite;
}

.nash-ai-orb {
  position: absolute;
  inset: -0.3rem;
  display: inline-flex;
  border-radius: 9999px;
  opacity: 0;
  transform: scale(0.94);
  filter: drop-shadow(0 0 18px rgba(56, 189, 248, 0.4))
    drop-shadow(0 0 26px rgba(37, 99, 235, 0.35))
    drop-shadow(0 0 32px rgba(192, 91, 255, 0.2));
  transition: opacity 220ms ease, transform 260ms ease, filter 260ms ease;
  pointer-events: none;
}

.nash-ai-orb.is-active {
  opacity: 1;
  transform: scale(1);
}

.nash-ai-orb.is-wake {
  filter: drop-shadow(0 0 22px rgba(56, 189, 248, 0.52))
    drop-shadow(0 0 32px rgba(37, 99, 235, 0.42))
    drop-shadow(0 0 36px rgba(192, 91, 255, 0.26));
}

.nash-ai-orb-svg {
  width: 100%;
  height: 100%;
}

.nash-ai-orb-ring-group {
  transform-origin: 50% 50%;
  animation: nash-ai-orb-spin 4.5s linear infinite;
}

.nash-ai-orb-ring {
  fill: none;
  stroke-linecap: round;
  transition: stroke-width 180ms ease;
}

.nash-ai-orb-ring.glow {
  opacity: 0.32;
  filter: blur(8px);
}

.nash-ai-orb-ring.core {
  opacity: 0.92;
}

.nash-ai-orb-ring.highlight {
  opacity: 0.75;
  filter: drop-shadow(0 0 8px rgba(124, 243, 255, 0.6));
}

.nash-ai-orb.is-active .nash-ai-orb-ring {
  stroke-width: 10.5;
}

.nash-ai-orb.is-wake .nash-ai-orb-ring-group {
  animation-duration: 3.25s;
}

@keyframes nash-ai-orb-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE;uCACqC;AACvC;;AAEA;EACE;;IAEE,+BAA+B;EACjC;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,UAAU;EACV,sBAAsB;EACtB;;iDAE+C;EAC/C,uEAAuE;EACvE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;;kDAEgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.nash-chat-trigger {\n  transition: box-shadow 200ms ease, transform 200ms ease;\n}\n\n.nash-chat-ring-active {\n  box-shadow: 0 0 0 4px rgba(224, 242, 254, 0.95), 0 0 0 8px rgba(34, 211, 238, 0.45),\n    0 0 0 12px rgba(59, 130, 246, 0.25);\n}\n\n@keyframes nash-chat-vibrate {\n  0%,\n  100% {\n    transform: translate3d(0, 0, 0);\n  }\n  20% {\n    transform: translate3d(-0.6px, 0.6px, 0);\n  }\n  40% {\n    transform: translate3d(0.6px, -0.6px, 0);\n  }\n  60% {\n    transform: translate3d(-0.6px, -0.6px, 0);\n  }\n  80% {\n    transform: translate3d(0.6px, 0.6px, 0);\n  }\n}\n\n.nash-chat-vibrate {\n  animation: nash-chat-vibrate 0.55s linear infinite;\n}\n\n.nash-ai-orb {\n  position: absolute;\n  inset: -0.3rem;\n  display: inline-flex;\n  border-radius: 9999px;\n  opacity: 0;\n  transform: scale(0.94);\n  filter: drop-shadow(0 0 18px rgba(56, 189, 248, 0.4))\n    drop-shadow(0 0 26px rgba(37, 99, 235, 0.35))\n    drop-shadow(0 0 32px rgba(192, 91, 255, 0.2));\n  transition: opacity 220ms ease, transform 260ms ease, filter 260ms ease;\n  pointer-events: none;\n}\n\n.nash-ai-orb.is-active {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.nash-ai-orb.is-wake {\n  filter: drop-shadow(0 0 22px rgba(56, 189, 248, 0.52))\n    drop-shadow(0 0 32px rgba(37, 99, 235, 0.42))\n    drop-shadow(0 0 36px rgba(192, 91, 255, 0.26));\n}\n\n.nash-ai-orb-svg {\n  width: 100%;\n  height: 100%;\n}\n\n.nash-ai-orb-ring-group {\n  transform-origin: 50% 50%;\n  animation: nash-ai-orb-spin 4.5s linear infinite;\n}\n\n.nash-ai-orb-ring {\n  fill: none;\n  stroke-linecap: round;\n  transition: stroke-width 180ms ease;\n}\n\n.nash-ai-orb-ring.glow {\n  opacity: 0.32;\n  filter: blur(8px);\n}\n\n.nash-ai-orb-ring.core {\n  opacity: 0.92;\n}\n\n.nash-ai-orb-ring.highlight {\n  opacity: 0.75;\n  filter: drop-shadow(0 0 8px rgba(124, 243, 255, 0.6));\n}\n\n.nash-ai-orb.is-active .nash-ai-orb-ring {\n  stroke-width: 10.5;\n}\n\n.nash-ai-orb.is-wake .nash-ai-orb-ring-group {\n  animation-duration: 3.25s;\n}\n\n@keyframes nash-ai-orb-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
